import type { ReactElement } from "react";
import { useNavigate } from "react-router";

type BreadcrumbsElement = {
  name: string;
  href?: string;
};

const PageLayout = ({
  children,
  breadcrumbs,
}: {
  children: ReactElement;
  breadcrumbs: BreadcrumbsElement[];
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={"flex flex-col bg-base-200"}>
        <div className="flex w-full h-screen flex-col p-4 overflow-y-auto">
          <div className="text-2xl font-semibold mb-2">
            <div className="breadcrumbs text-sm">
              <ul>
                {breadcrumbs.map((breadcrumb) => (
                  <li
                    key={breadcrumb.name + ':' + breadcrumb.href}
                    onClick={
                      breadcrumb.href
                        ? () => navigate(breadcrumb.href!)
                        : undefined
                    }
                  >
                    <a>{breadcrumb.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export default PageLayout;
